export type SearchParamsType = {
  pageNumber: number;
  pageSize: number;
  sortField: string;
  sortOrder: string;
  filter:{
    searchText:string
    status:number
  }
};

export type MasterTableDataType = {
    rosId: number;
    clinicId: number;
    rosCode: string;
    rosName: string;
    rosStatus: number;
    rosCreatedByDate: string;
    rosCreatedById: number;
    bodySystemName: string;
    bodySystemId:number
};


export type MasterDataType = {
    // rosId: number;
    // rosCode: string;
    // rosName: string;
    // bodySystemId: number;
    // status: number;
    // rosCreatedByDate: string;
    // rosCreatedById: number;
    // clinicId: number;

    rosId: number;
    rosCode: string;
    rosName: string;
    bodySystemId: number;
    status: number;
    rosCreatedByDate: string;
    rosCreatedById: number;
    clinicId: number;
};



export type SaveResponseType = {};

export type MasterFormDataType = {
  rosCode: string;
  rosName: string;
  rosStatus: number;
  bodysystem:{ bodySystemName:string,bodySystemId:number }  | null;
};

export const initialFormData: MasterFormDataType = {
  rosCode: "",
  rosName: "",
  rosStatus: 1,
  bodysystem:null,
};
